import { render, staticRenderFns } from "./table-sm.vue?vue&type=template&id=b72a9fa2&scoped=true&"
import script from "./table-sm.vue?vue&type=script&lang=js&"
export * from "./table-sm.vue?vue&type=script&lang=js&"
import style0 from "./table-sm.vue?vue&type=style&index=0&id=b72a9fa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72a9fa2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b72a9fa2')) {
      api.createRecord('b72a9fa2', component.options)
    } else {
      api.reload('b72a9fa2', component.options)
    }
    module.hot.accept("./table-sm.vue?vue&type=template&id=b72a9fa2&scoped=true&", function () {
      api.rerender('b72a9fa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personal-employee/finance/components/account-history-table/table-sm.vue"
export default component.exports